import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { ADMIN_URL, HOTEL_URL } from './constant/BaseApiUrl';

export default class DestinationService {
  getDestinations(listDestinationsId) {
    return axios.post(`${HOTEL_URL}${ApiKey.GET_DESTINATIONS}`, listDestinationsId);
  }

  getDestinationsOnlyHotel() {
    return axios.get(`${HOTEL_URL}${ApiKey.GET_DESTINATIONS_ONLY_HOTEL}`);
  }

  addDestinationsGroup(body) {
    return axios.post(`${HOTEL_URL}${ApiKey.DESTINATION_GROUP}`, body);
  }

  updateDestinationGroup(body) {
    return axios.put(`${HOTEL_URL}${ApiKey.DESTINATION_GROUP}`, body);
  }

  getSeasonalCalendar(body) {
    return axios.post(`${ADMIN_URL}${ApiKey.SEASONAL_CALENDAR}`, body);
  }
}
